import { z } from "@/zod";
import { DATE_FORMAT } from "./date-formats";
import { FILE_TYPE } from "./file-types";
import { QUANTITY } from "./quantity";
import validation from "./validation";
import visualization from "./visualization";

export const cfg = z.object({
  validation,
  minLength: z.coerce.number().nonnegative().min(0),
  maxLength: z.coerce.number().nonnegative().max(1000),
  minChecked: z.coerce.number().nonnegative().min(0),
  maxChecked: z.coerce.number().nonnegative().min(0),
  visualization,
  variants: z.array(
    z.object({
      variant: z.string().min(1).max(50),
    }),
  ),
  type: z.enum([...DATE_FORMAT, ...FILE_TYPE]),
  quantity: z.enum(QUANTITY),
  minQuantity: z.coerce.number().nonnegative().int().min(0),
  maxQuantity: z.coerce.number().nonnegative().int().max(10),
});
